import { render } from "preact";
import { App } from "./App";
import { captureInitialRender } from "./performance";
import "./styles.css";

const root = document.getElementById("root")!;
const renderStartedAt = performance.now();
render(<App />, root);
captureInitialRender(root, renderStartedAt);
